export default {
  'Download Mobile App': "Télécharger l'application",
  'Buy Now': 'Acheter',
  'Contact Us': 'Contactez-nous',
  'Copyright @ 2020, Famikit.com. All rights reserved.': 'Copyright @ 2020, Famikit.com. Tous droits réservés.',
  'Welcome to FamiKit': 'Bienvenue à FamiKit',
  'Sign in': 'Se connecter',
  'Home': 'Accueil',
  'Sreen Time': "Temps d'écran",
  'Apps Time': "Utilisation d'apps",
  'Website Filter': 'Blocage du contenu',
  'Geofences': 'Geofences',
  'Notifications': 'Notifications',
  'My': 'Mon compte',
  'Screen time': "Temps d'écran",
  'Most apps used': 'Les apps les plus utilisées',
  'No data display': 'Pas de données',
  "You have not installed Famikit on your child's phone. After installation, you can reopen Famikit on this device to see the statistics of children's mobile phones.": "Il vous faut installer FamiKit sur le téléphone de votre enfant. Après l'installation, rouvrez FamiKit pour afficher les statistiques du téléphone.",
  'What should I do ?': 'Que dois-je faire ?',
  "1. Get the child's cell phone": "1. Prenez le téléphone de l'enfant",
  '2. Open Google play, search and install famikit': '2. Ouvrez Google Play, recherchez et installez FamiKit',
  '3. Clock in famikit and log in（ {email} ）, select role child': "3. Lancez FamiKit et connectez-vous ( {email} ), sélectionnez le rôle d'enfant",
  '4. Follow the instructions in famikit to set permissions': "4. Suivez les instructions de FamiKit sur les autorisations",
  'Name': 'Nom',
  'Used time': 'Temps utilisé',
  'Limit duration': 'Durée limite',
  'Restricted period': "Période d'arrêt",
  'Limit set': 'Limite',
  'Set App usage time': "Définir la durée d'utilisation des apps",
  'Limit wechat usage time': "Limiter le temps d'utilisation de WeChat",
  'Note: set the maximum time that the app can be used': "Remarque: définissez la durée maximale d'utilisation de l'application",
  'Repeat': 'Répéter',
  'Save': 'Enregistrer',
  'Cancel': 'Annuler',
  'hour': 'heure',
  'min': 'min',
  'Set app usage period': "Définir la période d'utilisation de l'application",
  'Start': 'Démarrer',
  'End': 'Fin',
  'Limit Screen usage time': "Limiter le temps d'utilisation de l'écran",
  'Limited to {time} hours per day': "Limité à {time} heures par jour",
  'Set screen usage time': "Définir la durée d'utilisation de l'écran",
  'Set exception app': "Définir une application d'exception",
  'Limit screenusage time': "Limiter le temps d'utilisation de l'écran",
  'Exception app can be used without time limit': "L'application d'exception peut être utilisée pendant la limite de temps",
  'Email cannot be blank.': "L'e-mail ne peut pas être vide",
  'Please enter a valid email address': 'Veuillez saisir une adresse e-mail valide',
  "Password": "Mot de passe",
  "Repeat Password": "Confirmer le mot de passe",
  'I agree': "J'accepte",
  'User agreement': "l'accord d'utilisation",
  'and': 'et',
  'Privacy policy': 'la politique de confidentialité',
  'Register': "S'inscrire",
  'Existing account?': "J'ai eu un compte",
  'Password cannot be blank.': 'Le mot de passe ne peut pas être vide.',
  'Repeat Password cannot be blank.': 'Confirmer le mot de passe ne peut pas être vide.',
  'The two passwords you entered do not match.': 'Les mots de passe que vous avez saisis ne correspondent pas.',
  'Please read and agree to the terms of service first.': "Veuillez d'abord lire et accepter les conditions d'utilisation.",
  'Username already exists.': "Ce nom d'utilisateur est déjà utilisé.",
  'unexpected error.': 'erreur inattendue.',
  'Email': 'E-mail',
  'Network delay, please try again.': "Délai du réseau, veuillez réessayer.",
  'Incomplete parameters.': 'Paramètres incomplets.',
  'Username does not exist.': "Le nom d'utilisateur n'existe pas.",
  'Incorrect username or password.': "Nom d'utilisateur ou mot de passe incorrect.",
  'Return': 'Retour',
  'Choose your subscription plan and get started': 'Choisissez votre abonnement et démarrez',
  "Note: the number of devices refers to the number of children's devices that can be bound. Binding is to access your child's device and install it from Google play.": "Remarque: Le nombre d'appareils fait référence au nombre d'appareils pour enfants qui peut être lié. Vous devez avoir accès à l'appareil de votre enfant et installer FamiKit à partir de Google Play.",
  'Register now': 'Inscrivez-vous',
  'No account?': "Je n'ai pas de compte",
  'Add to Cart': 'Ajouter au panier',
  'Store': 'Boutique',
  'MONTHLY': 'MENSUEL',
  '$ 7.99 / Month': '$ 7.99 par mois',
  'Can be bound to': 'Peut être lié à',
  'devices': 'appareils',
  '$ 5.99 / Month': '$ 5.99 par mois',
  '$ 4.99 / Month': '$ 4.99 par mois',
  'Subscribe': "S'abonner",
  'QUARTERLY': 'TRIMESTRIEL',
  'ANNUAL': 'ANNUEL',
  'Note': 'Remarque',
  'download New Version Note!': 'Nouvelle version disponible!',
  'No': 'Non',
  'Yes': 'Oui',
  'Account expired': 'Compte expiré',
  'Account expired Please renew!': 'Votre compte a expiré, veuillez le renouveler!',
  'New data is uploading, it may take a while.': 'De nouvelles données sont en cours de téléchargement, cela peut prendre du temps.',
  "1. Get your kid's cell phone.": "1. Accédez au téléphone portable de l'enfant.",
  "2. Visit famikit.com in browser, download and install FamiKit App.": "2. Visitez famikit.com dans le navigateur, téléchargez et installez FamiKit.",
  "3. Open FamiKit app, sign in（ {email} ）and select kid's role.": "3. Ouvrez l'application FamiKit, connectez-vous ({email}) et sélectionnez le rôle de l'enfant.",
  '4. Follow the instructions in FamiKit to set permissions.': '4.Suivez les instructions de FamiKit sur les autorisations.',
  '5. Refresh this page.': '5. Actualisez cette page.',
  'Refresh Now.': 'Actualiser',
  'Limited to {time} per day': 'Limité à {time} par jour',
  'Current account is not activated.': "Ce compte n'est pas activé.",
  'About': 'À propos',
  'User privacy agreement': "Accord de confidentialité de l'utilisateur",
  'No data found': 'Aucune donnée trouvée',
  'Updated {times} ago': 'Mis à jour il y a {times}',
  'No location information': 'Aucune information de localisation',
  'please wait...': 'Veuillez patienter...',
  'Used for': 'Utilisé',
  'Today': "Aujourd'hui",
  'Yesterday': 'Hier',
  'Last 3 Days': '3 derniers jours',
  'Last 7 Days': '7 derniers jours',
  'Social contact': 'Applications sociales',
  'Other': 'Autres',
  'Game': 'Jeux',
  'Please confirm': 'Veuillez confirmer que',
  '1. The childs mobile phone is connected to the Internet and the position switch is turned on.': "1. Le téléphone de l'enfant est connecté à Internet et l'option de localisation est activé.",
  '2. Whether the famikit in the childs mobile phone is turned on.': "2. FamiKit est activé sur le téléphone de l'enfant.",
  'OK': 'OK',
  'Valid until': "Valable jusqu'au",
  'Update subscription': "Mettre à jour l'abonnement",
  'kids equipment': "Appareil pour enfants",
  'Disconnect': 'Déconnexion',
  'My Account': 'Mon compte',
  'Sign out': 'Déconnexion',
  'Cancel account': 'Résilier le compte',
  'You will not be able to receive device status after disconnection. Are you sure you want to disconnect ?': "Vous ne pouvez plus recevoir l'état de l'appareil une fois déconnecté. Êtes-vous sûr de vouloir vous déconnecter?",
  'Are you sure you want to exit ?': 'Êtes-vous sûr de vouloir quitter?',
  'Warning: after the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?': 'Attention: une fois que le compte est annulé, vos données seront effacées et ne pourront pas être récupérées. Êtes-vous sûr de vouloir résilier le compte?',
  'Delete all': 'Supprimer tout',
  'Mark all as read': 'Tout marquer comme lu',
  'Limit time interval': 'Intervalle de temps limite',
  'Set Time Limits': 'Définir les limites de temps',
  'Set screen usage period': "Définir la période d'utilisation de l'écran",
  'Set app time limit': "Définir la limite de temps de l'application",
  'Limit usage period': "Limiter la période d'utilisation",
  'Monday': 'lundi',
  'Tuesday': 'mardi',
  'Wednesday': 'mercredi',
  'Thursday': 'jeudi', 
  'Friday': 'vendredi',
  'Saturday': 'samedi',
  'Sunday': 'dimanche',
  'Add exception': 'Ajouter une exception',
  'Search locations': 'Rechercher des lieux',
  'Rule': 'Règle',
  'Prevent': 'Prévenir',
  'Allow': 'Autoriser',
  'Website filtering': 'Filtre de site Web',
  'Customize site access, block or allow': "Personnaliser l'accès au site, bloquer ou autoriser",
  'Are you sure you want to delete the filter settings ?': 'Êtes-vous sûr de vouloir supprimer les paramètres de filtre ?',
  'Filtering web browser access by category and URL': "Filtrer l'accès au navigateur Web par catégorie et URL",
  '（Only Chrome browser is supported）': '(Seul le navigateur Chrome est pris en charge)',
  '$ {Month} / Month': '$ {Month} / Mois',
  'Radius of the geofence in meters ({0}) m max.': 'Le demi-diamètre de la geofence en mètres ({0}) m au maximum.',
  'Out': 'En dehors',
  'In': 'Dedans',
  'search': 'Rechercher',
  'Name the Geofence': 'Nommez la Geofence',
  'NameBeBlank': 'Le nom ne peut pas être vide',
  'Radius of the geofence in meters （1000m max.）': 'Le demi-diamètre de la geofence en mètres (1000m au maximum.)',
  'Are you sure you want to select the deleted geofence': 'Êtes-vous sûr de vouloir sélectionner la geofence supprimée',
  'Most Used': 'Les Plus utilisés',
  'Set Limits': 'Définir des limites',
  'Limit Screen Time': "Limiter le temps d'écran",
  'Allow: {time} ': 'Autoriser: {time} ',
  'Downtime': "Temps d'arrêt",
  'Note: This is the maximum time that kid’s phone can be used.': "Remarque: il s'agit de la durée maximale pendant laquelle le téléphone d'enfant peut être utilisé.",
  'Always Allowed': 'Toujours permis',
  'Choose apps that your kids can use all the time.': 'Choisissez les applications que vos enfants peuvent utiliser tout le temps.',
  'Duration Limit': 'Limite de durée',
  'Customize site access: Prevent or Allow.': "Personnalisez l'accès au site: Interdiction ou Autorisation.",
  'Enter URL': "Entrer l'URL",
  'Restriction': 'Restriction',
  'Exception': 'Exception',
  'Adult': 'Contenu adulte',
  'Alcohol': 'Alcool & Tabac',
  'Anonymizers': 'Anonyme',
  'Gambling': "Jeux d'argent",
  'Games': 'Jeux',
  'Job': 'Emploi',
  'Music': 'Musique & Vidéo',
  'News': 'Les actualités',
  'Profanity': 'Impiété',
  'Religions': 'Religions',
  'Search': 'Rechercher',
  'Shopping': 'Achats',
  'Social': 'Applications sociales',
  'Unknown': 'Inconnu',
  'Violence': 'Violence',
  'Weapons': 'Armes',
  'Try it now': 'Essayez maintenant',
  'Your kid cannot use the device during the time limit.': "Votre enfant ne peut pas utiliser l'appareil pendant le délai",
  'famiKit（ {ver} ）is now available for your kid. Please go toGoogle Play Store and install the latest version of Famikit on yourkid’s device': "FamiKit ({ver}) est maintenant disponible pour votre enfant. Veuillez vous rendre sur Google Play Store et installer la dernière version de FamiKit sur l'appareil de votre enfant.",
  'famikit（ {ver} ）is now available for your kid. Please go to': "FamiKit ({ver}) est maintenant disponible pour votre enfant. S'il vous plaît allez à",
  'famikit.com': 'famikit.com',
  'and install the latest version of Famikit for PC on yours device': 'et installez la dernière version de FamiKit pour PC sur votre appareil.',
  '3. Open FamiKit app, sign in（ {email} ）': "3. Ouvrez l'application FamiKit, connectez-vous ({email})",
  'Kid device is Android': "L'appareil pour enfants est Android",
  'Kid device is Windows': "L'appareil enfant est Windows",
  '2. Visit famikit.com in browser, download and install Famikit App.': "2. Ouvrez famikit.com dans le navigateur, téléchargez et installez l'application FamiKit.",
  "1. Get your kid's PC": "1. Accédez au PC de votre enfant",
  '2. Download FamiKit android app from Google Play': "2. Téléchargez l'application Android FamiKit sur Google Play Store",
  'Browser Histroy': 'Historique du navigateur',
  'Enable Brower History': "Activez l'historique du navigateur",
  'After opening, it will record the browsing records of chrome, Firefox, edge and other browsers.': "Après avoir activé l'option, il enregistrera l'historique de navigation de Chrome, Firefox, Edge et d'autres navigateurs."
}




// WEBPACK FOOTER //
// ./src/language/fr.js